{
  "de": {
    "announcement": {
      "actions": {
        "allUpdates": "Alle Updates",
        "delete_announcement": "Neuigkeit löschen",
        "edit": "Bearbeiten",
        "new": "Neuigkeit",
        "pin": "Oben anheften",
        "retry": "Erneut versuchen",
        "save": "Speichern",
        "submit": "Veröffentlichen",
        "unpin": "Von oben lösen"
      },
      "attributes": {
        "description": "Beschreibung"
      },
      "labels": {
        "allUnits": "alle Einheiten",
        "archiveSubtitle": "Alles, was wir zu {project} veröffentlicht haben, neueste zuerst.",
        "customers": "Kunden",
        "for": "für",
        "image_tab": "Bild",
        "notSeenYet": "Noch nicht gesehen",
        "now": "Jetzt",
        "pinned": "Diese Ankündigung wird oben auf der Seite des Kunden angezeigt.",
        "pinnedBadge": "Angeheftet",
        "seen": "Gesehen",
        "seenByCount": "{count} von {total} gesehen",
        "sharedWithPrefix": "Geteilt mit",
        "sharedWithProject": "Geteilt mit {units} von {project}",
        "someUnits": "einige Einheiten",
        "start": "Start",
        "unitsCount": "1 Einheit | {count} Einheiten",
        "video_tab": "Video",
        "youtube_video": "YouTube-Video-URL"
      },
      "name": "Ankündigung",
      "placeholders": {
        "customers": {
          "failed": {
            "subtitle": "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
            "title": "Die Updates konnten nicht geladen werden"
          },
          "missing": {
            "title": "Dieses Update ist nicht mehr verfügbar"
          },
          "none": {
            "subtitle": "Bald finden Sie hier regelmäßige Updates von der Baustelle auf Ihrem Dashboard.",
            "title": "Hier finden Sie Ihre Neuigkeiten!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Begrüßen Sie Ihre Kunden oder teilen Sie ein Update zum Projekt.",
            "title": "Erstellen Sie Ihre erste Neuigkeit"
          },
          "none": {
            "project_required": "Wählen Sie ein Projekt aus",
            "selectProject": "Wählen Sie ein Projekt aus und legen Sie los!",
            "subtitle": "Begrüßen Sie Ihre Kunden oder teilen Sie ein Update zu einem beliebigen Projekt."
          },
          "paste_video_url": "Fügen Sie hier Ihren YouTube-Link ein"
        }
      },
      "toasts": {
        "create": "Neuigkeit veröffentlicht",
        "delete": "Neuigkeit gelöscht",
        "invalid_video": "Dies ist kein gültiges YouTube-Video",
        "update": "Neuigkeit wurde aktualisiert"
      },
      "validation": {
        "pleaseAddContent": "Fügen Sie ein Bild, ein Video oder eine Beschreibung hinzu"
      }
    }
  }
}
